import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { PiniaColada } from '@pinia/colada'
import ui from '@nuxt/ui/vue-plugin'
import App from '@/App.vue'

import { router } from '@/router'
import { i18n } from '@/locales'

import {
  VueGlobalPropertiesPlugin,
  MQPlugin,
  SentryPlugin,
  ChunkReloadPlugin
} from '@/plugins'
import { setupSwUpdate } from '@/features/platform/pwa/sw-update'

import '@/assets/styles/main.css'

window.siteData = {
  commit: import.meta.env.VITE_APP_VERSION,
  env: import.meta.env.VITE_ENV
}

const app = createApp(App)

app
  .use(SentryPlugin)
  .use(ChunkReloadPlugin)
  .use(createPinia())
  .use(PiniaColada)
  .use(router)
  .use(i18n)
  .use(ui)
  .use(MQPlugin)
  .use(VueGlobalPropertiesPlugin)

setupSwUpdate(router)

router.isReady().then(() => {
  app.mount('#app')
})

export {
  app
}
